import $ from 'jquery';
import BaseModule from './BaseModule';

export default class Navbar extends BaseModule {
  constructor(el, factory) {
    super(el, factory, 'Navbar');
    const thisEl = $(el);

    function closeNav() {
      $('body').removeClass('navbar-expanded');
      $('.navbar').removeClass('expanded');
      $('.nav-link.has-sub').removeClass('active');
      $('.navbar-nav.show').removeClass('show');
      thisEl.find('.navbar-nav').removeClass('pushed');
      $('.navbar-backdrop').remove();
    }

    // Toggle burger menu
    thisEl.on('click', '.navbar-toggler', function (e) {
      e.preventDefault();

      if (!thisEl.hasClass('expanded')) {
        if (!thisEl.hasClass('active') && $(window).width() < 768) {
          thisEl.addClass('active');
          $('body').addClass('body-fixed');
          $('.navbar-collapse .navbar-nav')[0].scrollIntoView({
            block: 'end',
            inline: 'start',
          });
        } else {
          // Closing menu on mobile
          thisEl.removeClass('active show-search');
          $('.car-sub.show').removeClass('show');
          $('.car-cta').appendTo($('.navbar-nav--new'));
          thisEl.find('.navbar-nav').removeClass('pushed car-pushed');
          $('body').removeClass('body-fixed');
        }
      } else {
        closeNav();
      }
    });

    // Opening sub menu
    thisEl.on('click', '.nav-link.has-sub', function (e) {
      e.preventDefault();

      if ($(window).width() >= 768) {
        $('.navbar').addClass('expanded');
        $('body').addClass('navbar-expanded');

        if ($('.navbar').children('.navbar-backdrop').length === 0) {
          $('.navbar').prepend('<div class="navbar-backdrop"></div>');

          $('.navbar-backdrop').on('click', function () {
            closeNav();
          });
        }
      }
      $('.nav-link.has-sub').removeClass('active');
      $('.navbar-nav.show').removeClass('show');
      $(this).addClass('active').next().addClass('show');
      $(this).parents('.navbar-nav').addClass('pushed');
    });

    // Going back to level 1 sub menu on mobile
    thisEl.on('click', '.nav-link-back', function (e) {
      e.preventDefault();
      const navbar = $(this).parents('.navbar-nav');

      if ($(this).parents('.car-sub').length > 0) {
        navbar.removeClass('car-pushed');
        $('.car-cta').appendTo($('.navbar-nav--new'));
        setTimeout(function () {
          $('.car-sub').removeClass('show');
        }, 500);
      } else {
        navbar.removeClass('pushed');
        setTimeout(function () {
          navbar.removeClass('show');
        }, 500);
      }
    });

    // Opening car sub (level 2 sub) menu on mobile
    thisEl.on('click', '.has-car-sub', function (e) {
      e.preventDefault();
      $(this).parents('.navbar-nav.pushed').addClass('car-pushed');
      $(this).next().addClass('show');
      $('.car-pushed')[0].scrollIntoView({
        block: 'end',
        inline: 'start',
      });
      $('.car-cta').appendTo($(this).next());
    });

    // Scroll sticky
    let vNav = 0;
    const sectionList = [];
    if ($('.section-vehicle-nav').length > 0) {
      $('.section-vehicle-nav .nav-link').each(function () {
        sectionList.push($(this).attr('data-target'));
      });
    }

    window.onscroll = function () {
      if (window.pageYOffset > 5) {
        thisEl.addClass('sticky');
      } else {
        thisEl.removeClass('sticky');
      }

      if ($('[scroll-active-disabled]').length === 0 && $('.section-vehicle-nav').length > 0) {
        vNav = $('.section-vehicle-nav').offset().top;
        const vNavHeight = $('.section-vehicle-nav').outerHeight();
        if (window.pageYOffset + 100 > vNav) {
          thisEl.css({
            top: (vNav - window.pageYOffset) - 100,
          });
        } else {
          thisEl.removeAttr('style');
        }

        if (window.pageYOffset === vNav) {
          $('.section-vehicle-nav').addClass('sticky');
        } else {
          $('.section-vehicle-nav').removeClass('sticky');
        }

        if (!$('body').hasClass('scroll-animating')) {
          sectionList.forEach((element, index) => {
            const elm = $(element);
            const elmTop = elm.position().top;
            const elmBottom = elmTop + elm.outerHeight();

            if (elmTop - vNavHeight <= window.pageYOffset && elmBottom > window.pageYOffset) {
              $('.section-vehicle-nav .nav-link').removeClass('active').eq(index).addClass('active');
            } else {
              $('.section-vehicle-nav .nav-link').eq(index).removeClass('active');
            }
          });
        }
      }
    };
  }
}
